import { render } from "./FeaturesSection.vue?vue&type=template&id=1955f844&scoped=true"
const script = {}

import "./FeaturesSection.vue?vue&type=style&index=0&id=1955f844&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1955f844"]])

export default __exports__